import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';

import logo from './../../images/logo/Stargiga.png';

class Header extends Component{
	constructor(props) {
		super(props);
		this.state = { isScrolled: false };
		this.handleScroll = this.handleScroll.bind(this);
	}

	componentDidMount() {

        // sidebar open/close

        var Navicon = document.querySelector('.navicon');
        var sidebarmenu = document.querySelector('.myNavbar ');

        function toggleFunc() {
            sidebarmenu.classList.toggle('show');
            Navicon.classList.toggle('open');
        }
        Navicon.addEventListener('click', toggleFunc);


        // Sidenav li open close
        var navUl = [].slice.call(document.querySelectorAll('.navbar-nav > li'));
        for (var y = 0; y < navUl.length; y++) {
            navUl[y].addEventListener('click', function () { checkLi(this) });
        }
		
		
        function checkLi(current) {
            navUl.forEach(el => (current !== el) ? el.classList.remove('open') : '');
            
			setTimeout(() => {
			
			current.classList.toggle('open');
			
			/* alert(current.className.indexOf('open'));
				if(current.className.indexOf('open') == -1){
					current.classList.toggle('open');
					alert(2);
				}else{
				alert(current.parentNode);
					current.parentNode.classList.add('khelesh');
				} */
				
			}, 100);
						
        }

		// Toggle glass fixed header after a small scroll.
		this.handleScroll();
		window.addEventListener('scroll', this.handleScroll, { passive: true });
	}

	componentWillUnmount() {
		window.removeEventListener('scroll', this.handleScroll);
	}

	handleScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
		const shouldBeScrolled = scrollTop > 8;
		if (shouldBeScrolled !== this.state.isScrolled) {
			this.setState({ isScrolled: shouldBeScrolled });
		}
	}
	render(){
		return(
			<Fragment>
				{/*  header  */}
				<style>{`
					/* Keep header sticky always; only apply glass styling after scrolling a little */
					.site-header.header-transparent{
						position: fixed !important;
						top: 0;
						left: 0;
						width: 100%;
						z-index: 1000;
						background: transparent;
					}
					.site-header.header-transparent.header-scrolled {
						backdrop-filter: blur(18px) saturate(180%);
						-webkit-backdrop-filter: blur(18px) saturate(180%);
						background: rgba(12, 14, 22, 0.55);
						transition: background 0.2s ease, backdrop-filter 0.2s ease;
					}
					.site-header.header-transparent.header-scrolled .top-bar{
						display: none !important;
					}
					.site-header.header-transparent.header-scrolled .main-bar{
						background: rgba(12, 14, 22, 0.55) !important;
						backdrop-filter: blur(18px) saturate(180%) !important;
						-webkit-backdrop-filter: blur(18px) saturate(180%) !important;
						border-bottom: 1px solid rgba(255,255,255,0.08);
					}
					.site-header.header-transparent.header-scrolled .header-nav .nav > li > a{
						color: #ffffff !important;
					}
					.site-header.header-transparent.header-scrolled .header-nav .nav > li > a i{
						color: #ffffff !important;
					}
				`}</style>
				<header className={`site-header header-transparent${this.state.isScrolled ? ' header-scrolled' : ''}`}>
					<HeaderContent />					
				</header>
				{/*  header End  */}
			</Fragment>
		)
	}
}
function HeaderContent(){
	return(
		<>
			<div className="top-bar">
				<div className="container-fluid">
					<div className="row d-flex justify-content-md-between justify-content-center align-items-center">
						<div className="dlab-topbar-left">
							<ul>
								<li>
									<i className="la la-phone-volume"></i>
									<a href="tel:+97167412344" style={{ color: 'inherit', textDecoration: 'none' }}>+971 67 412 344</a>
								</li>
								<li><i className="las la-map-marker"></i> Address Ajman, United Arab Emirates</li>
							</ul>
						</div>
						<div className="dlab-topbar-right">
							<ul>
								{/* <li><i className="la la-clock"></i>  Mon - Sat 8.00 - 18.00</li> */}
								<li><i className="las la-envelope-open"></i> info@stargiga.com</li>
							</ul>				
						</div>
					</div>
				</div>
			</div>
			{/*   main header  */}
			<div className="sticky-header main-bar-wraper navbar-expand-lg">
				<div className="main-bar clearfix ">
					<div className="container-fluid clearfix">
					{ /* website logo */ }
					<div className="logo-header mostion logo-dark">
						<Link to={"./"}><img src={logo} alt="" /></Link>
					</div>
					{/* nav toggle button  */}
					<button className="navbar-toggler collapsed navicon justify-content-end " type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
						<span></span>
						<span></span>
						<span></span>
					</button>
					{/*extra nav  */}
					<div className="extra-nav">
						<div className="extra-cell">
							<Link to={"/contact-us?siteVisit=1"} className="btn btn-primary btnhover13">Book a Site Visit</Link>
						</div>
					</div>
					<div className="header-nav navbar-collapse collapse myNavbar justify-content-end" id="navbarNavDropdown">
						<div className="logo-header d-md-block d-lg-none">
							<Link to={"./"}><img src={logo} alt="" /></Link>
						</div>
						<ul className="nav navbar-nav navbar">	
							<li><Link to={"./"}>Home</Link></li>
							<li><Link to={"/about-us"}>About Us</Link></li>
							<li>
								<Link to={"/projects"}>Projects<i className="fa fa-chevron-down"></i></Link>
								<ul className="sub-menu">
									<li><Link to={"/projects"}>Completed</Link></li>
									<li>
										<Link to={"/ongoing-project"}>Ongoing </Link>
									</li>
								</ul>
							</li>
							<li><Link to={"/sustainability"}>Sustainability</Link></li>
							<li><Link to={"/ajman-exhibition"}>Gallery</Link></li>
						
							{/* <li><Link to={"#"}>Portfolio<i className="fa fa-chevron-down"></i></Link>
								<ul className="sub-menu">
									<li><Link to={"/portfolio-1"}>Portfolio 1</Link></li>
									<li><Link to={"/portfolio-2"}>Portfolio 2</Link></li>
									<li><Link to={"/project-detail-1"}>Project Detail 1</Link></li>
									<li><Link to={"/project-detail-2"}>Project Detail 2</Link></li>
									<li><Link to={"/project-detail-3"}>Project Detail 3</Link></li>
									<li><Link to={"/project-detail-4"}>Project Detail 4</Link></li>
								</ul>
							</li> */}
							{/* <li><Link to={"/blog-masonry"}>Blogs</Link></li> */}
							{/* <li><Link to={"/careers"}>Careers</Link></li> */}
							<li><Link to={"/contact-us"}>Contact Us</Link></li>
						</ul>
						<div className="dlab-social-icon">
							<ul>
								<li><a href="https://www.facebook.com/StarGigaUAE" target="_blank" rel="noopener noreferrer" className="site-button circle fa fa-facebook" aria-label="Facebook"></a></li>
								<li><a href="https://x.com/stargigauae" target="_blank" rel="noopener noreferrer" className="site-button circle fa fa-twitter" aria-label="Twitter"></a></li>
								<li><a href="https://www.linkedin.com/company/stargigauae/" target="_blank" rel="noopener noreferrer" className="site-button circle fa fa-linkedin" aria-label="LinkedIn"></a></li>
								<li><a href="https://www.youtube.com/user/gigagroup" target="_blank" rel="noopener noreferrer" className="site-button circle fa fa-youtube" aria-label="YouTube"></a></li>
							</ul>
						</div>		
					</div>
				</div>
				</div>
			</div>
		</>
	)
} 
export {HeaderContent};
export default Header;